type RepoKind = 'biltyn' | 'conductor' | 'unknown';

function repoKind(targetRepo?: string): RepoKind {
  if (targetRepo === 'sidwellgrav/biltyn') return 'biltyn';
  if (targetRepo === 'sidwellgrav/conductor') return 'conductor';
  return 'unknown';
}

const STYLE: Record<RepoKind, { label: string; background: string; color: string }> = {
  biltyn: { label: 'BILTYN · PRODUCTION', background: 'var(--red-bg)', color: 'var(--red)' },
  conductor: { label: 'CONDUCTOR', background: 'var(--blue-bg, #dbeafe)', color: 'var(--blue, #1d4ed8)' },
  unknown: { label: 'REPO?', background: 'var(--gray-bg)', color: 'var(--gray)' },
};

export default function RepoBadge({
  targetRepo,
  size = 'small',
}: {
  targetRepo?: string;
  size?: 'small' | 'large';
}) {
  const { label, background, color } = STYLE[repoKind(targetRepo)];
  return (
    <span
      className="badge"
      style={{ background, color, fontSize: size === 'large' ? 13.5 : 10.5, fontWeight: 700 }}
    >
      {label}
    </span>
  );
}
